import { httpV2 } from "@/api";

const Qs = require("qs");

/**
* @summary Obtém sensores, podendo ser filtrado por equipamentos.
* @param {object} parameters Parâmetros da requisição dos sensores
* recebe filterBy e os ids dos equipamentos, quando filterBy = 1.
* @returns {array} Array com os sensores requisitados.
*/
const GetSensors = function(parameters)
{
	const params = {
		filterBy: parameters.filterBy,
		ids:      parameters.ids
	};

	return httpV2.get("Sensors/", {
		params:           params,
		paramsSerializer: params => Qs.stringify(params, { arrayFormat: "repeat" })
	});
};

/**
* @summary Obtém o status de um conjunto de sensores.
* @param {array} sIds Ids do elemento de monitoração do tipo sensors
* @returns {array} Array com o status dos sensores requisitados.
*/
const GetSensorsStatus = (sIds) =>
{
	const parameters = { sIds: sIds };

	return httpV2.get("/SensorsStatus", {
		params:           parameters,
		paramsSerializer: params => Qs.stringify(params, { arrayFormat: "repeat" })
	});
};

/**
* @summary Obtém os valores globais de um conjunto de sensores de uma turbina eólica.
* @param {object} parameters Contém sIds (os ids dos sensores), aggregateOption (Nacelle ou Pitch)
* e measure (aceleração ou velocidade).
* @returns {array} Array com os valores globais dos sensores.
*/
const GetWindTurbineSensorsGlobalValues = ({
	sIds, aggregateOption, measure
}) =>
{
	const params = {
		sIds:            sIds,
		aggregateOption: aggregateOption,
		measure:         measure
	};

	return httpV2.get("/WindTurbineGlobalValues", {
		params:           params,
		paramsSerializer: params => Qs.stringify(params, { arrayFormat: "repeat" })
	});
};

export default {
	GetSensors,
	GetSensorsStatus,
	GetWindTurbineSensorsGlobalValues
};
